/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createShapeId,
  pointInPolygon,
  StateNode,
  TLPointerEventInfo,
  TLUnknownShape,
  Vec,
} from "tldraw"
import { LDPage } from "../../shared/LDPage"

export class LDOrigin extends StateNode {
  static override id = "origin"

  info = {} as TLPointerEventInfo

  isPen = false
  isPenOrStylus = false

  markId = null as null | string
  override onPointerMove(info: TLPointerEventInfo): void {
    // Make the pointer icon a crosshair
    this.editor.setCursor({
      type: "cross",
    })
  }

  override onPointerDown(info: TLPointerEventInfo): void {
    this.info = info

    this.editor.markHistoryStoppingPoint()

    //console.log(`Point is inside the shape ${finalShape.id}`)

    const pageId = this.editor.getCurrentPageId()
    const page = this.editor.getPage(pageId) as LDPage
    this.editor.updatePage({
      id: pageId,
      meta: {
        ...page.meta,
        origin: {
          x: this.info.point.x,
          y: this.info.point.y - 64 + 10,
        },
        originSet: true,
      },
    })
    this.editor.setCurrentTool("select")
  }
}
